// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/lista/{owner}/{owner_id}
 *
 * Returns a list of payment links for the given owner. Each row is a payment
 * link record from the local DB; the shape mirrors payment_links table and is
 * not strictly typed at the contract layer.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_ListaResponseDados = unknown[];

export type SubaccountsLinks_ListaResponse = ApiResponse<SubaccountsLinks_ListaResponseDados>;

registerResponseContract('SubaccountsLinks_ListaResponse', {})
